import React from 'react';
import { useLanguage } from '../context/LanguageContext';

export default function Disclaimer() {
  const { language } = useLanguage();

  return (
    <div data-testid="disclaimer-page">
      <section className="py-32 lg:py-40 bg-white">
        <div className="max-w-3xl mx-auto px-6 lg:px-8">
          <h1 className="text-3xl sm:text-4xl font-bold text-[#08080A] mb-10" data-testid="disclaimer-title">
            Disclaimer
          </h1>

          <div className="prose prose-gray max-w-none space-y-6 text-[#555] leading-relaxed">
            <p>
              {language === 'nl'
                ? 'De informatie op deze website is met zorg samengesteld. Kesult kan echter niet garanderen dat de informatie op elk moment volledig, juist of actueel is. Aan de inhoud van deze website kunnen geen rechten worden ontleend.'
                : 'The information on this website has been compiled with care. However, Kesult cannot guarantee that the information is complete, accurate or up-to-date at all times. No rights can be derived from the content of this website.'}
            </p>

            <h2 className="text-xl font-bold text-[#08080A] pt-4">
              {language === 'nl' ? 'Aansprakelijkheid' : 'Liability'}
            </h2>
            <p>
              {language === 'nl'
                ? 'Kesult is niet aansprakelijk voor schade die het gevolg is van het gebruik van informatie op deze website. Het gebruik van de website en de daarop gepubliceerde informatie is volledig voor eigen risico.'
                : 'Kesult is not liable for damages resulting from the use of information on this website. The use of the website and the information published on it is entirely at your own risk.'}
            </p>

            <h2 className="text-xl font-bold text-[#08080A] pt-4">
              {language === 'nl' ? 'Links naar derden' : 'Third-party links'}
            </h2>
            <p>
              {language === 'nl'
                ? 'Deze website kan links bevatten naar websites van derden. Kesult heeft geen invloed op de inhoud van deze websites en is niet verantwoordelijk voor de inhoud of het privacybeleid ervan.'
                : 'This website may contain links to third-party websites. Kesult has no influence on the content of these websites and is not responsible for their content or privacy policies.'}
            </p>

            <h2 className="text-xl font-bold text-[#08080A] pt-4">
              {language === 'nl' ? 'Intellectueel eigendom' : 'Intellectual property'}
            </h2>
            <p>
              {language === 'nl'
                ? 'Alle teksten, afbeeldingen en overige content op deze website zijn eigendom van Kesult, tenzij anders vermeld. Niets van deze website mag worden verveelvoudigd, opgeslagen of openbaar gemaakt zonder voorafgaande schriftelijke toestemming van Kesult.'
                : 'All texts, images and other content on this website are the property of Kesult, unless stated otherwise. Nothing from this website may be reproduced, stored or published without prior written permission from Kesult.'}
            </p>

            <h2 className="text-xl font-bold text-[#08080A] pt-4">
              {language === 'nl' ? 'Wijzigingen' : 'Changes'}
            </h2>
            <p>
              {language === 'nl'
                ? 'Kesult behoudt zich het recht voor om de inhoud van deze disclaimer op elk moment te wijzigen zonder voorafgaande kennisgeving.'
                : 'Kesult reserves the right to change the content of this disclaimer at any time without prior notice.'}
            </p>

            <div className="pt-6 border-t border-gray-100 mt-8">
              <p className="text-sm text-[#999]">
                {language === 'nl'
                  ? 'Kesult — Eenmanszaak — KVK 42002486'
                  : 'Kesult — Sole proprietorship — KVK 42002486'}
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
